export const TOGGLE_TIME_FILTER_MENU = 'ibw/SearchTime/TOGGLE_TIME_FILTER_MENU';
